
import { Options, Vue } from "vue-class-component";
import { ref } from "vue";
import * as echarts from "echarts";
import {
  dispatchGetReportStat,
  dispatchGetVisitStatistics,
  dispatchGetVisitStatTrend,
  dispatchGetTopPerformanceOld,
  dispatchGetTopProjectPerformance,
  dispatchGetTopLabelPerformance,
  dispatchGetTopModelPerformance,
  dispatchGetTopLevelPerformance,
  dispatchGetTopTesterPerformance,
  dispatchGetProjects,
  dispatchGetMyProjects,
} from "@/store/project/actions";
import { store } from "@/store";
import { ElMessage } from "element-plus";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
} from "@/store/project/getters";
import {
  readReportStat,
  readVisitStatistics,
  readVisitStatTrend,
  readtopPerformanceOld,
  readtopProjectPerformance,
  readtopLabelPerformance,
  readtopModelPerformance,
  readtopLevelPerformance,
  readtopTesterPerformance,
} from "@/store/project/getters";
import {
  dispatchDeepTopDownLoad,
  dispatchUploadTopPerformance,
  dispatchDeletetopPerformance,
} from "@/store/performance/actions";
@Options({
  components: {},
})
export default class OperationalData extends Vue {
  public localProject = Number(getLocalProject());
  public current_page = 1;
  public loadProgress = 0; // 动态显示进度条
  public progressFlag = false; // 关闭进度条

  public get projectList() {
    return readtopProjectPerformance(store);
  }
  public get tagList() {
    return readtopLabelPerformance(store);
  }
  public get modelList() {
    return readtopModelPerformance(store);
  }
  public get levelList() {
    return readtopLevelPerformance(store);
  }
  public get testerList() {
    return readtopTesterPerformance(store);
  }
  public async deleteData() {
    await dispatchDeletetopPerformance(store, {
      project: this.localProject,
      id_list: this.checkList,
    });
    ElMessage.success({
      message: "删除成功",
      showClose: true,
      type: "success",
    });
    await dispatchGetTopPerformanceOld(store, {
      project: this.localProject,
      page: this.current_page,
      size: this.record,
      label: this.form.label.join(";"),
      model: this.form.model.join(";"),
      level: this.form.level == "" ? "" : Number(this.form.level),
      tester: this.form.tester,
      project_name: this.form.project ? this.form.project : "",
      id_test: this.$route.query.id_test,
      label_main: decodeURI(this.$route.query.label_main as any),
    });
    this.get_all_performance.forEach((v) => {
      v.is_check = false;
    });
  }
  public async downloadCsv() {
    const response_data = dispatchDeepTopDownLoad(store, {
      project: Number(this.localProject),
      label: this.form.label.join(";"),
      model: this.form.model.join(";"),
      level: this.form.level,
      tester: this.form.tester,
      project_name: this.form.project,
      id_test: this.$route.query.id_test,
      label_main: decodeURI(this.$route.query.label_main as any),
    });
    response_data.then((value) => {
      var elink = document.createElement("a");
      elink.download = this.form.project ? this.form.project : "全部" + ".xls";
      elink.style.display = "none";
      var blob = new Blob([value], { type: "application/vnd.ms-excel" });
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    });
  }
  public checkList = [];
  public handleCheck(row, value) {
    this.checkList = [];
    if (row.length > 0) {
      this.get_all_performance.forEach((v) => {
        v.is_check = true;
        this.checkList.push(v.id);
      });
    } else {
      this.get_all_performance.forEach((v) => {
        v.is_check = false;
        this.checkList = [];
      });
    }
  }
  public form = {
    project: "",
    label: [],
    model: [],
    level: "",
    tester: "",
  };
  public dialogForm = {
    scene_id: "",
    is_valid: true,
    b_auto_collect: false,
    remark: "",
    UUID: "",
    task_record_id: "",
    task_group_index: "",
  };
  public beforeRemove(file) {
    let index_num = 0;
    this.fileList.forEach((v, index) => {
      if (v.uid == file.uid) {
        index_num = index;
      }
    });
    this.fileList.splice(index_num, 1);
  }
  public beforeUpload(file: any) {
    let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let isLt2M = file.size / 1024 / 1024 < 50;
    if (["xls", "xlsx"].indexOf(extension) === -1) {
      ElMessage.error({
        message: "只能上传后缀是.xlsx/.xls的文件",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload"] as any).clearFiles();
    }
    if (!isLt2M) {
      ElMessage.error({
        message: "上传文件大小不能超过50MB!",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload"] as any).clearFiles();
    }
    return extension && isLt2M;
  }
  public async submitUpload(btn: string) {
    if (btn === "open") {
      this.dialogVisible = true;
      this.dialogForm = {
        scene_id: "",
        is_valid: true,
        b_auto_collect: false,
        remark: "",
        UUID: "",
        task_record_id: "",
        task_group_index: "",
      };
      // this.formData = new FormData();
      // (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "no") {
      this.dialogForm1.project = "";
      this.dialogForm1.url = "";
      this.dialogForm = {
        scene_id: "",
        is_valid: true,
        b_auto_collect: false,
        remark: "",
        UUID: "",
        task_record_id: "",
        task_group_index: "",
      };
      this.formData = new FormData();
      (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "ok") {
      if (this.dialogForm1.project == "") {
        ElMessage.error({
          message: "请选择项目",
          showClose: true,
          type: "error",
        });
        return;
      } else {
        this.formData.append("project", this.localProject);
        this.formData.append("project_name", this.dialogForm1.project);
        this.formData.append("url", this.dialogForm1.url);
        this.fileList.forEach((item, index) => {
          this.formData.append("file", item);
        });

        this.checkList = [];
        this.current_page = 1;
        this.record = 16;

        this.form.label = [];
        this.form.model = [];
        this.form.level = "";
        this.form.tester = "";
        this.dialogVisible = false;
        this.uploadShow = true;
        let b = (this as any).$message({
          //Message 消息提示
          message: "上传中",
          showClose: true,
          duration: 0,
        });
        await dispatchUploadTopPerformance(store, this.formData);
        this.uploadShow = false;
        b.close();
        ElMessage.success({
          message: "数据上传成功",
          showClose: true,
          type: "success",
        });
        this.formData = new FormData();
        this.fileList = [];
        (this.$refs["upload"] as any)?.clearFiles();
      }
      await dispatchGetTopProjectPerformance(store, {
        project: this.localProject,
      });
      this.form.project =
        this.projectList.length > 0 ? this.projectList[0].project_name : "";
      await dispatchGetTopPerformanceOld(store, {
        project: this.localProject,
        page: 1,
        size: this.record,
        label: "",
        model: "",
        level: "",
        tester: "",
        project_name: this.form.project ? this.form.project : "",
        id_test: this.$route.query.id_test,
        label_main: decodeURI(this.$route.query.label_main as any),
      });
      this.get_all_performance.forEach((v) => {
        v.is_check = false;
      });
    }
  }
  //  public IsValidChange(item){
  //    console.log(item)
  //  }
  public async selectTableChange(operation: any) {
    this.checkList = [];
    (this.current_page = operation == "paging" ? this.current_page : 1),
      (this.record = operation == "paging" ? this.record : 16);
    if (operation === "project") {
      dispatchGetTopLabelPerformance(store, {
        project: this.localProject,
        project_name: this.form.project,
      });
      this.form.label = [];
      // dispatchGetTopModelPerformance(store, {
      //  project: this.localProject,
      // });
      // dispatchGetTopLevelPerformance(store, {
      //  project: this.localProject,
      // });
      // dispatchGetTopTesterPerformance(store, {
      //  project: this.localProject,
      // });
    }

    await dispatchGetTopPerformanceOld(store, {
      project: this.localProject,
      page: this.current_page,
      size: this.record,
      label: this.form.label.join(";"),
      model: this.form.model.join(";"),
      level: this.form.level == "" ? "" : Number(this.form.level),
      tester: this.form.tester,
      project_name: this.form.project ? this.form.project : "",
      id_test: this.$route.query.id_test,
      label_main: decodeURI(this.$route.query.label_main as any),
    });
    this.get_all_performance.forEach((v) => {
      v.is_check = false;
    });
  }
  public fileList = [];
  public fileList1 = [];
  public async UploadFile(param: any, file) {
    this.fileList.push(param.file);
    // this.formData.append('file',)
  }
  uploadVideoProcess(event, file, fileList) {
    this.progressFlag = true; // 显示进度条
    this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
    if (this.loadProgress >= 100) {
      this.loadProgress = 100;
      setTimeout(() => {
        this.progressFlag = false;
      }, 1000); // 一秒后关闭进度条
    }
  }

  public formData: any = new FormData();
  public dialogVisible = false;
  public record = 16; //记录条数
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  public indexMethod(index: any) {
    return index + 1 + (this.current_page - 1) * this.record;
  }
  public async onTableClear() {
    this.checkList = [];
    this.form.project = "";
    this.form.label = [];
    this.form.model = [];
    this.form.level = "";
    this.form.tester = "";
    this.current_page = 1;
    this.record = 16;
    await dispatchGetTopPerformanceOld(store, {
      project: this.localProject,
      page: 1,
      size: this.record,
      label: "",
      model: "",
      level: "",
      tester: "",
      project_name: this.form.project ? this.form.project : "",
      id_test: this.$route.query.id_test,
      label_main: decodeURI(this.$route.query.label_main as any),
    });
    this.get_all_performance.forEach((v) => {
      v.is_check = false;
    });
  }
  public handleDetail(row) {
    const { href } = this.$router.resolve({
      path: "/TopSubData",
      query: {
        ...this.$route.query,
        id_test: row.id_test,
        label_main: decodeURI(this.$route.query.label_main as any),
      },
    });
    window.open(href, "_blank");
  }
  public uploadShow = false;
  public PerfFields = [
    // { label: "序号", prop: "index", width: 60 },
    { label: "测试时间", prop: "date", width: 180 },
    { label: "Label场景", prop: "label_name", width: 180 },
    { label: "分档信息", prop: "level", width: 100 },
    { label: "设备型号", prop: "model", width: 100 },
    // { label: "测试人员", prop: "tester", width: 100 },
    // { label: "CPU型号", prop: "cpu_model", width: 100 },
    // { label: "CPU核数", prop: "core_num", width: 100 },
    // { label: "GPU型号", prop: "gpu_model", width: 100 },
    // { label: "内存大小", prop: "ram", width: 100 },
    // { label: "系统版本", prop: "os", width: 100 },
    // { label: "CPU频率", prop: "cpu_freq", width: 100 },
    // { label: "CPU评分", prop: "cpu_score", width: 100 },
    // { label: "GPU评分", prop: "gpu_score", width: 100 },
    // { label: "屏幕类型", prop: "screen_type", width: 100 },
    // { label: "屏幕分辨率", prop: "resolution", width: 100 },
    // { label: "屏幕刷新率", prop: "refresh", width: 100 },
    // { label: "CPU位数", prop: "cpu_bits", width: 100 },
    // { label: "OpenglEs", prop: "OpenglEs", width: 100 },
    // { label: "用户量占比", prop: "user_percentage", width: 100 },
    // { label: "综合分", prop: "score", width: 100 },
    // { label: "默认画质", prop: "picture_quality", width: 100 },
    { label: "avgFPS", prop: "avg_fps", width: 100 },
    { label: "FPS>18占有率(%)", prop: "fps_gt_18_pcnt", width: 100 },
    { label: "FPS>25占有率(%)", prop: "fps_gt_25_pcnt", width: 100 },
    { label: "平均PSS", prop: "avg_pss", width: 100 },
    { label: "峰值PSS", prop: "max_pss", width: 100 },
    { label: "avgCPU(%)", prop: "avg_cpu", width: 100 },
    { label: "CPU<90占有率(%)", prop: "cpu_lt_90_pcnt", width: 100 },
    { label: "Jank", prop: "jank", width: 100 },
    { label: "BigJank", prop: "big_jank", width: 100 },
    { label: "10min流量(kb)", prop: "min10_flow", width: 100 },
    { label: "cpu温度峰值(°C)", prop: "max_cpu_temp", width: 100 },
    { label: "cpu平均温度(°C)", prop: "cpu_temp", width: 100 },
    { label: "电池温度峰值(°C)", prop: "max_battery_temp", width: 100 },
    { label: "电池平均温度(°C)", prop: "battery_temp", width: 100 },
    { label: "温枪测温-开始温度(°C)", prop: "start_temp", width: 100 },
    { label: "cpu温度峰值-结束温度(°C)", prop: "end_temp", width: 100 },
    { label: "降频降帧", prop: "down_freq_down_frame", width: 100 },
    { label: "主观卡顿", prop: "caton", width: 100 },
    { label: "发热情况", prop: "fever", width: 100 },
    { label: "测试时长", prop: "duration", width: 100 },
    { label: "是否闪退", prop: "is_crash1", width: 100 },
    { label: "备注", prop: "remark", width: 100 },
  ];
  public getProjects(search?: string) {
    const projects: any[] = readMyProjects(store);
    return projects;
  }
  public iframeWin = "";
  public async mounted() {
    // let c = (this.$refs.iframeDom as any).contentWindow
    //  const oIframe = document.getElementById('bdIframe');
    // const deviceWidth = document.documentElement.clientWidth;
    // const deviceHeight = document.documentElement.clientHeight;
    // oIframe.style.width = (Number(deviceWidth)-220) + 'px'; //数字是页面布局宽度差值
    // oIframe.style.height = (Number(deviceHeight)-120) + 'px'; //数字是页面布局高度差

    // var data =
    //   {
    //       "id": "0",
    //       "id_row": 0,
    //       "parent_id": 1,
    //       "depth": -1,
    //       "is_leaf": false,
    //       "event_count": 1,
    //       "thread_eventcount": 1,
    //       "func_hash_id": 1,
    //       "frameIndex": 1,
    //       "thread_hash_id": 1,
    //       "lib_so_eventcount": 1,
    //       "process_eventcount": 1,
    //       "frameTime": 250.54,
    //       "is_exists": 0,
    //       "rate": 100,
    //       "value": 33.64,
    //       "name": "FrameTime",
    //       "children":
    //       [
    //         {
    //             "id": "5050390127205481522-89024355393547128870",
    //             "id_row": 1,
    //             "parent_id": 0,
    //             "depth": 0,
    //             "is_leaf": false,
    //             "event_count": 1843762,
    //             "thread_eventcount": 1843762,
    //             "func_hash_id": "-8902435539354712887",
    //             "frameIndex": 1,
    //             "thread_hash_id": "5050390127205481522",
    //             "lib_so_eventcount": 1,
    //             "process_eventcount": 6760144,
    //             "frameTime": 33.64,
    //             "is_exists": 0,
    //             "rate": 27.26,
    //             "value": 9.17,
    //             "name": "TaskGraphNP 0",
    //             "children":
    //             [
    //                 {
    //                     "id": "50503901272054815226218488909407214941",
    //                     "id_row": 2,
    //                     "parent_id": 1,
    //                     "depth": 1,
    //                     "is_leaf": false,
    //                     "event_count": 1843762,
    //                     "thread_eventcount": 1843762,
    //                     "func_hash_id": "621848890940721494",
    //                     "frameIndex": 1,
    //                     "thread_hash_id": "5050390127205481522",
    //                     "lib_so_eventcount": 1,
    //                     "process_eventcount": 6760144,
    //                     "frameTime": 33.64,
    //                     "is_exists": 0,
    //                     "rate": 100,
    //                     "value": 9.17,
    //                     "name": "__pthread_start",
    //                     "children":
    //                     [
    //                         {
    //                             "id": "5050390127205481522-66009277136955602872",
    //                             "id_row": 3,
    //                             "parent_id": 2,
    //                             "depth": 2,
    //                             "is_leaf": false,
    //                             "event_count": 1843762,
    //                             "thread_eventcount": 1843762,
    //                             "func_hash_id": "-6600927713695560287",
    //                             "frameIndex": 1,
    //                             "thread_hash_id": "5050390127205481522",
    //                             "lib_so_eventcount": 1843761,
    //                             "process_eventcount": 6760144,
    //                             "frameTime": 33.64,
    //                             "is_exists": 0,
    //                             "rate": 100,
    //                             "value": 9.17,
    //                             "name": "FRunnableThreadPThread::_ThreadProc",
    //                             "children":
    //                             [
    //                                 {
    //                                     "id": "5050390127205481522-9406162185942178073",
    //                                     "id_row": 4,
    //                                     "parent_id": 3,
    //                                     "depth": 3,
    //                                     "is_leaf": false,
    //                                     "event_count": 1843762,
    //                                     "thread_eventcount": 1843762,
    //                                     "func_hash_id": "-940616218594217807",
    //                                     "frameIndex": 1,
    //                                     "thread_hash_id": "5050390127205481522",
    //                                     "lib_so_eventcount": 1843761,
    //                                     "process_eventcount": 6760144,
    //                                     "frameTime": 33.64,
    //                                     "is_exists": 0,
    //                                     "rate": 100,
    //                                     "value": 9.17,
    //                                     "name": "FRunnableThreadPThread::Run",
    //                                     "children":
    //                                     [
    //                                         {
    //                                             "id": "505039012720548152287334285491490064674",
    //                                             "id_row": 5,
    //                                             "parent_id": 4,
    //                                             "depth": 4,
    //                                             "is_leaf": false,
    //                                             "event_count": 1843762,
    //                                             "thread_eventcount": 1843762,
    //                                             "func_hash_id": "8733428549149006467",
    //                                             "frameIndex": 1,
    //                                             "thread_hash_id": "5050390127205481522",
    //                                             "lib_so_eventcount": 1843761,
    //                                             "process_eventcount": 6760144,
    //                                             "frameTime": 33.64,
    //                                             "is_exists": 0,
    //                                             "rate": 100,
    //                                             "value": 9.17,
    //                                             "name": "FTaskThreadBase::Run",
    //                                             "children":
    //                                             [
    //                                                 {
    //                                                     "id": "5050390127205481522-33471074794224151725",
    //                                                     "id_row": 6,
    //                                                     "parent_id": 5,
    //                                                     "depth": 5,
    //                                                     "is_leaf": false,
    //                                                     "event_count": 1843762,
    //                                                     "thread_eventcount": 1843762,
    //                                                     "func_hash_id": "-3347107479422415172",
    //                                                     "frameIndex": 1,
    //                                                     "thread_hash_id": "5050390127205481522",
    //                                                     "lib_so_eventcount": 1843761,
    //                                                     "process_eventcount": 6760144,
    //                                                     "frameTime": 33.64,
    //                                                     "is_exists": 0,
    //                                                     "rate": 100,
    //                                                     "value": 9.17,
    //                                                     "name": "FTaskThreadAnyThread::ProcessTasksUntilQuit",
    //                                                     "children":
    //                                                     [
    //                                                         {
    //                                                             "id": "505039012720548152252196571148489880056",
    //                                                             "id_row": 7,
    //                                                             "parent_id": 6,
    //                                                             "depth": 6,
    //                                                             "is_leaf": false,
    //                                                             "event_count": 1843762,
    //                                                             "thread_eventcount": 1843762,
    //                                                             "func_hash_id": "5219657114848988005",
    //                                                             "frameIndex": 1,
    //                                                             "thread_hash_id": "5050390127205481522",
    //                                                             "lib_so_eventcount": 1843761,
    //                                                             "process_eventcount": 6760144,
    //                                                             "frameTime": 33.64,
    //                                                             "is_exists": 0,
    //                                                             "rate": 100,
    //                                                             "value": 9.17,
    //                                                             "name": "FTaskThreadAnyThread::ProcessTasks",
    //                                                             "children":
    //                                                             []
    //                                                         }
    //                                                     ]
    //                                                 }
    //                                             ]
    //                                         }
    //                                     ]
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 }
    //             ]
    //         },
    //         {
    //             "id": "-3415899517082488532-89024355393547128870",
    //             "id_row": 1,
    //             "parent_id": 0,
    //             "depth": 0,
    //             "is_leaf": false,
    //             "event_count": 510107,
    //             "thread_eventcount": 510107,
    //             "func_hash_id": "-8902435539354712887",
    //             "frameIndex": 1,
    //             "thread_hash_id": "-3415899517082488532",
    //             "lib_so_eventcount": 150,
    //             "process_eventcount": 6760144,
    //             "frameTime": 33.64,
    //             "is_exists": 0,
    //             "rate": 7.55,
    //             "value": 2.54,
    //             "name": "RenderThread",
    //             "children":
    //             [
    //                 {
    //                     "id": "-34158995170824885326218488909407214941",
    //                     "id_row": 2,
    //                     "parent_id": 1,
    //                     "depth": 1,
    //                     "is_leaf": false,
    //                     "event_count": 510107,
    //                     "thread_eventcount": 510107,
    //                     "func_hash_id": "621848890940721494",
    //                     "frameIndex": 1,
    //                     "thread_hash_id": "-3415899517082488532",
    //                     "lib_so_eventcount": 150,
    //                     "process_eventcount": 6760144,
    //                     "frameTime": 33.64,
    //                     "is_exists": 0,
    //                     "rate": 100,
    //                     "value": 2.54,
    //                     "name": "__pthread_start",
    //                     "children":
    //                     [
    //                         {
    //                             "id": "-3415899517082488532-66009277136955602872",
    //                             "id_row": 3,
    //                             "parent_id": 2,
    //                             "depth": 2,
    //                             "is_leaf": false,
    //                             "event_count": 510107,
    //                             "thread_eventcount": 510107,
    //                             "func_hash_id": "-6600927713695560287",
    //                             "frameIndex": 1,
    //                             "thread_hash_id": "-3415899517082488532",
    //                             "lib_so_eventcount": 504224,
    //                             "process_eventcount": 6760144,
    //                             "frameTime": 33.64,
    //                             "is_exists": 0,
    //                             "rate": 100,
    //                             "value": 2.54,
    //                             "name": "FRunnableThreadPThread::_ThreadProc",
    //                             "children":
    //                             [
    //                                 {
    //                                     "id": "-3415899517082488532-9406162185942178073",
    //                                     "id_row": 4,
    //                                     "parent_id": 3,
    //                                     "depth": 3,
    //                                     "is_leaf": false,
    //                                     "event_count": 510107,
    //                                     "thread_eventcount": 510107,
    //                                     "func_hash_id": "-940616218594217807",
    //                                     "frameIndex": 1,
    //                                     "thread_hash_id": "-3415899517082488532",
    //                                     "lib_so_eventcount": 504224,
    //                                     "process_eventcount": 6760144,
    //                                     "frameTime": 33.64,
    //                                     "is_exists": 0,
    //                                     "rate": 100,
    //                                     "value": 2.54,
    //                                     "name": "FRunnableThreadPThread::Run",
    //                                     "children":
    //                                     [
    //                                         {
    //                                             "id": "-341589951708248853221043326705869597334",
    //                                             "id_row": 5,
    //                                             "parent_id": 4,
    //                                             "depth": 4,
    //                                             "is_leaf": false,
    //                                             "event_count": 510107,
    //                                             "thread_eventcount": 510107,
    //                                             "func_hash_id": "2104332670586959733",
    //                                             "frameIndex": 1,
    //                                             "thread_hash_id": "-3415899517082488532",
    //                                             "lib_so_eventcount": 504224,
    //                                             "process_eventcount": 6760144,
    //                                             "frameTime": 33.64,
    //                                             "is_exists": 0,
    //                                             "rate": 100,
    //                                             "value": 2.54,
    //                                             "name": "FRenderingThread::Run",
    //                                             "children":
    //                                             [
    //                                                 {
    //                                                     "id": "-3415899517082488532-76798522613752893275",
    //                                                     "id_row": 6,
    //                                                     "parent_id": 5,
    //                                                     "depth": 5,
    //                                                     "is_leaf": false,
    //                                                     "event_count": 510107,
    //                                                     "thread_eventcount": 510107,
    //                                                     "func_hash_id": "-7679852261375289327",
    //                                                     "frameIndex": 1,
    //                                                     "thread_hash_id": "-3415899517082488532",
    //                                                     "lib_so_eventcount": 504224,
    //                                                     "process_eventcount": 6760144,
    //                                                     "frameTime": 33.64,
    //                                                     "is_exists": 0,
    //                                                     "rate": 100,
    //                                                     "value": 2.54,
    //                                                     "name": "RenderingThreadMain",
    //                                                     "children":
    //                                                     [
    //                                                         {
    //                                                             "id": "-341589951708248853278346677989141658256",
    //                                                             "id_row": 7,
    //                                                             "parent_id": 6,
    //                                                             "depth": 6,
    //                                                             "is_leaf": false,
    //                                                             "event_count": 510107,
    //                                                             "thread_eventcount": 510107,
    //                                                             "func_hash_id": "7834667798914165825",
    //                                                             "frameIndex": 1,
    //                                                             "thread_hash_id": "-3415899517082488532",
    //                                                             "lib_so_eventcount": 504224,
    //                                                             "process_eventcount": 6760144,
    //                                                             "frameTime": 33.64,
    //                                                             "is_exists": 0,
    //                                                             "rate": 100,
    //                                                             "value": 2.54,
    //                                                             "name": "FNamedTaskThread::ProcessTasksUntilQuit",
    //                                                             "children":
    //                                                             [
    //                                                                 {
    //                                                                     "id": "-341589951708248853243752735129926348607",
    //                                                                     "id_row": 8,
    //                                                                     "parent_id": 7,
    //                                                                     "depth": 7,
    //                                                                     "is_leaf": false,
    //                                                                     "event_count": 510107,
    //                                                                     "thread_eventcount": 510107,
    //                                                                     "func_hash_id": "4375273512992634860",
    //                                                                     "frameIndex": 1,
    //                                                                     "thread_hash_id": "-3415899517082488532",
    //                                                                     "lib_so_eventcount": 504224,
    //                                                                     "process_eventcount": 6760144,
    //                                                                     "frameTime": 33.64,
    //                                                                     "is_exists": 0,
    //                                                                     "rate": 100,
    //                                                                     "value": 2.54,
    //                                                                     "name": "FNamedTaskThread::ProcessTasksNamedThread",
    //                                                                     "children":
    //                                                                     []
    //                                                                 }
    //                                                             ]
    //                                                         }
    //                                                     ]
    //                                                 }
    //                                             ]
    //                                         }
    //                                     ]
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 }
    //             ]
    //         },
    //         {
    //             "id": "-3300155990551858843-72988660102855613990",
    //             "id_row": 1,
    //             "parent_id": 0,
    //             "depth": 0,
    //             "is_leaf": false,
    //             "event_count": 479355,
    //             "thread_eventcount": 479355,
    //             "func_hash_id": "-7298866010285561399",
    //             "frameIndex": 1,
    //             "thread_hash_id": "-3300155990551858843",
    //             "lib_so_eventcount": 479353,
    //             "process_eventcount": 6760144,
    //             "frameTime": 33.64,
    //             "is_exists": 0,
    //             "rate": 7.1,
    //             "value": 2.39,
    //             "name": "GameThread",
    //             "children":
    //             [
    //                 {
    //                     "id": "-330015599055185884326402945181350006111",
    //                     "id_row": 2,
    //                     "parent_id": 1,
    //                     "depth": 1,
    //                     "is_leaf": false,
    //                     "event_count": 479355,
    //                     "thread_eventcount": 479355,
    //                     "func_hash_id": "2640294518135000611",
    //                     "frameIndex": 1,
    //                     "thread_hash_id": "-3300155990551858843",
    //                     "lib_so_eventcount": 479353,
    //                     "process_eventcount": 6760144,
    //                     "frameTime": 33.64,
    //                     "is_exists": 0,
    //                     "rate": 100,
    //                     "value": 2.39,
    //                     "name": "FEngineLoop::Tick",
    //                     "children":
    //                     [
    //                         {
    //                             "id": "-330015599055185884314908544024046152032",
    //                             "id_row": 3,
    //                             "parent_id": 2,
    //                             "depth": 2,
    //                             "is_leaf": false,
    //                             "event_count": 479355,
    //                             "thread_eventcount": 479355,
    //                             "func_hash_id": "1490854402404615203",
    //                             "frameIndex": 1,
    //                             "thread_hash_id": "-3300155990551858843",
    //                             "lib_so_eventcount": 479353,
    //                             "process_eventcount": 6760144,
    //                             "frameTime": 33.64,
    //                             "is_exists": 0,
    //                             "rate": 100,
    //                             "value": 2.39,
    //                             "name": "UGameEngine::Tick",
    //                             "children":
    //                             []
    //                         }
    //                     ]
    //                 }
    //             ]
    //         },
    //         {
    //             "id": "2652576766114995334-89024355393547128870",
    //             "id_row": 1,
    //             "parent_id": 0,
    //             "depth": 0,
    //             "is_leaf": false,
    //             "event_count": 462349,
    //             "thread_eventcount": 462349,
    //             "func_hash_id": "-8902435539354712887",
    //             "frameIndex": 1,
    //             "thread_hash_id": "2652576766114995334",
    //             "lib_so_eventcount": 4724,
    //             "process_eventcount": 6760144,
    //             "frameTime": 33.64,
    //             "is_exists": 0,
    //             "rate": 6.84,
    //             "value": 2.3,
    //             "name": "TaskGraphNP 1",
    //             "children":
    //             [
    //                 {
    //                     "id": "26525767661149953346218488909407214941",
    //                     "id_row": 2,
    //                     "parent_id": 1,
    //                     "depth": 1,
    //                     "is_leaf": false,
    //                     "event_count": 462349,
    //                     "thread_eventcount": 462349,
    //                     "func_hash_id": "621848890940721494",
    //                     "frameIndex": 1,
    //                     "thread_hash_id": "2652576766114995334",
    //                     "lib_so_eventcount": 4724,
    //                     "process_eventcount": 6760144,
    //                     "frameTime": 33.64,
    //                     "is_exists": 0,
    //                     "rate": 100,
    //                     "value": 2.3,
    //                     "name": "__pthread_start",
    //                     "children":
    //                     [
    //                         {
    //                             "id": "2652576766114995334-66009277136955602872",
    //                             "id_row": 3,
    //                             "parent_id": 2,
    //                             "depth": 2,
    //                             "is_leaf": false,
    //                             "event_count": 462349,
    //                             "thread_eventcount": 462349,
    //                             "func_hash_id": "-6600927713695560287",
    //                             "frameIndex": 1,
    //                             "thread_hash_id": "2652576766114995334",
    //                             "lib_so_eventcount": 457623,
    //                             "process_eventcount": 6760144,
    //                             "frameTime": 33.64,
    //                             "is_exists": 0,
    //                             "rate": 100,
    //                             "value": 2.3,
    //                             "name": "FRunnableThreadPThread::_ThreadProc",
    //                             "children":
    //                             [
    //                                 {
    //                                     "id": "2652576766114995334-9406162185942178073",
    //                                     "id_row": 4,
    //                                     "parent_id": 3,
    //                                     "depth": 3,
    //                                     "is_leaf": false,
    //                                     "event_count": 462349,
    //                                     "thread_eventcount": 462349,
    //                                     "func_hash_id": "-940616218594217807",
    //                                     "frameIndex": 1,
    //                                     "thread_hash_id": "2652576766114995334",
    //                                     "lib_so_eventcount": 457623,
    //                                     "process_eventcount": 6760144,
    //                                     "frameTime": 33.64,
    //                                     "is_exists": 0,
    //                                     "rate": 100,
    //                                     "value": 2.3,
    //                                     "name": "FRunnableThreadPThread::Run",
    //                                     "children":
    //                                     [
    //                                         {
    //                                             "id": "265257676611499533487334285491490064674",
    //                                             "id_row": 5,
    //                                             "parent_id": 4,
    //                                             "depth": 4,
    //                                             "is_leaf": false,
    //                                             "event_count": 462349,
    //                                             "thread_eventcount": 462349,
    //                                             "func_hash_id": "8733428549149006467",
    //                                             "frameIndex": 1,
    //                                             "thread_hash_id": "2652576766114995334",
    //                                             "lib_so_eventcount": 457623,
    //                                             "process_eventcount": 6760144,
    //                                             "frameTime": 33.64,
    //                                             "is_exists": 0,
    //                                             "rate": 100,
    //                                             "value": 2.3,
    //                                             "name": "FTaskThreadBase::Run",
    //                                             "children":
    //                                             [
    //                                                 {
    //                                                     "id": "2652576766114995334-33471074794224151725",
    //                                                     "id_row": 6,
    //                                                     "parent_id": 5,
    //                                                     "depth": 5,
    //                                                     "is_leaf": false,
    //                                                     "event_count": 462349,
    //                                                     "thread_eventcount": 462349,
    //                                                     "func_hash_id": "-3347107479422415172",
    //                                                     "frameIndex": 1,
    //                                                     "thread_hash_id": "2652576766114995334",
    //                                                     "lib_so_eventcount": 457623,
    //                                                     "process_eventcount": 6760144,
    //                                                     "frameTime": 33.64,
    //                                                     "is_exists": 0,
    //                                                     "rate": 100,
    //                                                     "value": 2.3,
    //                                                     "name": "FTaskThreadAnyThread::ProcessTasksUntilQuit",
    //                                                     "children":
    //                                                     [
    //                                                         {
    //                                                             "id": "265257676611499533452196571148489880056",
    //                                                             "id_row": 7,
    //                                                             "parent_id": 6,
    //                                                             "depth": 6,
    //                                                             "is_leaf": false,
    //                                                             "event_count": 462349,
    //                                                             "thread_eventcount": 462349,
    //                                                             "func_hash_id": "5219657114848988005",
    //                                                             "frameIndex": 1,
    //                                                             "thread_hash_id": "2652576766114995334",
    //                                                             "lib_so_eventcount": 457623,
    //                                                             "process_eventcount": 6760144,
    //                                                             "frameTime": 33.64,
    //                                                             "is_exists": 0,
    //                                                             "rate": 100,
    //                                                             "value": 2.3,
    //                                                             "name": "FTaskThreadAnyThread::ProcessTasks",
    //                                                             "children":
    //                                                             []
    //                                                         }
    //                                                     ]
    //                                                 }
    //                                             ]
    //                                         }
    //                                     ]
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 }
    //             ]
    //         }
    //       ]
    //   }
    //  setTimeout(
    //         () => {
    //             c.postMessage({
    //                 cmd:data,
    //                 apiUrl: 3,
    //                 params: {}
    //             }, '*')
    //         }, 200);

    await dispatchGetMyProjects(store);
    await dispatchGetTopProjectPerformance(store, {
      project: this.localProject,
    });
    this.form.project =
      this.projectList.length > 0 ? this.projectList[0].project_name : "";

    await dispatchGetTopLabelPerformance(store, {
      project: this.localProject,
      project_name: this.form.project,
    });
    dispatchGetTopPerformanceOld(store, {
      project: this.localProject,
      page: this.current_page,
      size: this.record,
      label: "",
      model: "",
      level: "",
      tester: "",
      project_name: this.form.project ? this.form.project : "",
      id_test: this.$route.query.id_test,
      label_main: decodeURI(this.$route.query.label_main as any),
    });
    dispatchGetTopModelPerformance(store, {
      project: this.localProject,
    });
    dispatchGetTopLevelPerformance(store, {
      project: this.localProject,
    });
    dispatchGetTopTesterPerformance(store, {
      project: this.localProject,
    });
  }

  public dialogForm1 = {
    project: "",
    url: "",
  };
  public checkChange(item) {
    if (item.is_check == true) {
      this.checkList.push(item.id);
    } else {
      this.checkList = this.checkList.filter((v) => v != item.id);
    }
  }
  public get readPerformancePageList() {
    return readtopPerformanceOld(store);
  }
  public height = "1000px";
  public get get_all_performance() {
    let res: any[] = readtopPerformanceOld(store).results;
    for (let i = 0; i < res?.length; i++) {
      // res[i].model = this.getDeviceSpecs.filter(
      //   (item) => item.id === res[i].device_id
      // )[0]?.model.model;
      res[i].index = i + 1;
      res[i].timestamp = dateConversion(res[i].test_time);
      res[i].is_crash1 = res[i].is_crash == false ? "否" : "是";
      for (let x in res[i]) {
        if (res[i][x] == null) {
          res[i][x] = "-";
        }
      }
    }
    return res;
  }
  //   public c=0
  //     async mounted(){
  //         console.log(this.ss())
  //           let n= await this.getData1()
  //         console.log(n)
  //        let c= await this.getData()
  //          console.log(this.ss())
  //          console.log(c)
  //     }
  //     public  target = 'Hello World'
  //     public ss(){
  //        return (this.target)
  //     }
  //    public getData(){
  //    return new Promise((resolve) =>{
  //      setTimeout(() => {
  //         resolve(this.target='2')
  //      }, 2000);
  //     })
  // }
  //    public getData1(){
  //    return new Promise((resolve) =>{
  //      setTimeout(() => {
  //         resolve(3123)
  //      }, 1000);
  //     })
  // }
}
